export default __webpack_public_path__ + "static/media/img-in-wallet.9e717ade.png";